<template>
  <div class="info_cheart_ct">
    <el-card style="height:100%">
      <p>企业注册地与经营地情况统计</p>
      <div ref="ehachrValue" class="ehcartds" style="height:90%"></div>
    </el-card>
  </div>
</template>

<script>
import { infoDataSetGir } from "@/network";
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {
    this.handEcharts();
  },
  methods: {
    async getSetGir() {},
    handEcharts() {
      let echarts = this.$echarts.init(this.$refs.ehachrValue);
      let option = {
        title: {
          subtext: "(企业数量)",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {},
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: [
            "注册地与经营地均在本街道",
            "注册地在本街道",
            "经营地在本街道",
          ],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            barWidth: "30%",
            data: [120, 200, 150],
            type: "bar",
          },
        ],
      };
      echarts.setOption(option);
    },
  },
};
</script>

<style lang="less">
.info_cheart_ct {
  height: 400px;
  .el-card__body {
    height: 100%;
  }
}
</style>
